export default {"src":"/_next/static/media/jxMetal.616d06cc.svg","height":123,"width":304,"blurWidth":0,"blurHeight":0};